/* Treatment rows: regroup existing content without rewriting clinical instructions.
   Care advice in the featured text («Før behandling» / «Etter behandling» headings) becomes ONE row,
   «Før og etter behandling», with the two headings kept as subheadings. Nodes are moved intact, never
   rebuilt; unknown formats stay where they are, and nothing is dropped except empty paste paragraphs. */
(() => {
  const CARE_INTRO = /^(For best resultat og for å unngå bivirkninger, følg disse rådene nøye:|For beste mulig resultat og for unngå bivirkninger, ber vi deg følge disse rådene nøye:)$/i;
  const CARE_HEADING = /^(Før|Etter) behandling(?:en)?:?$/i;
  const PHONE_HELP = 'Finner du ikke ledig tid på ønsket dag eller tidspunkt, er du velkommen til å ringe oss på 458 01 000. Vi har enkelte tilgjengelige timer som ikke ligger ute på nett, og hjelper deg gjerne med å finne en passende time.';
  const text = node => (node.textContent || '').replace(/\s+/g, ' ').trim();

  function row(label) {
    const item = document.createElement('details');
    item.className = 'll-treatment-panel';
    const summary = document.createElement('summary');
    summary.textContent = label;
    const toggle = document.createElement('span');
    toggle.className = 'll-accordion__toggle';
    toggle.setAttribute('aria-hidden', 'true');
    summary.append(toggle);
    const content = document.createElement('div');
    content.className = 'll-accordion__panel rte';
    item.append(summary, content);
    return { item, content };
  }

  function enhance(root) {
    if (root.dataset.enhanced) return;
    root.dataset.enhanced = 'true';
    const description = root.querySelector('[data-treatment-description]');
    const featured = root.querySelector('[data-treatment-featured]');
    const explanation = root.querySelector('[data-treatment-explanation]');

    // Empty paste artifacts add large gaps but carry no information.
    [description, featured].filter(Boolean).forEach(source => {
      Array.from(source.children).forEach(node => {
        if (node.tagName === 'P' && !text(node) && !node.querySelector('img, video, iframe')) node.remove();
      });
    });

    // Availability help: kept, as its own short row instead of a long paragraph in the description.
    let booking = null;
    if (description) {
      Array.from(description.children).forEach(node => {
        if (text(node) !== PHONE_HELP) return;
        booking = row('Timebestilling');
        const help = document.createElement('p');
        help.append('Finner du ikke en tid som passer? Ring ');
        const phone = document.createElement('a');
        phone.href = 'tel:+4745801000';
        phone.textContent = '458 01 000';
        help.append(phone, '. Vi har også enkelte timer som ikke vises på nett.');
        booking.content.append(help);
        node.remove();
      });
    }

    // Care advice: only known top-level headings start a group; the nodes after them move intact.
    let care = null;
    if (featured) {
      let target = null;
      let intro = null;
      Array.from(featured.children).forEach(node => {
        const value = text(node);
        if (CARE_INTRO.test(value)) { intro = node; return; }
        if (CARE_HEADING.test(value)) {
          if (!care) care = row('Før og etter behandling');
          if (intro) { care.content.append(intro); intro = null; }
          // A styled paragraph, as in the source text: no heading level to skip under the page's H1.
          const heading = document.createElement('p');
          heading.className = 'll-treatment-panels__subheading';
          heading.textContent = /^Før/i.test(value) ? 'Før behandling' : 'Etter behandling';
          care.content.append(heading);
          target = care.content;
          node.remove();
        } else if (target) {
          target.append(node);
        }
      });
    }

    // Place the rows: care after the explanation (or in its place when nothing else was left), then booking help.
    const anchor = explanation && featured && text(featured) ? explanation : null;
    let after = anchor || explanation || root.querySelector('[data-treatment-overview]') || root.lastElementChild;
    [care, booking].filter(Boolean).forEach(group => {
      if (after && after.parentNode === root) after.after(group.item);
      else root.append(group.item);
      after = group.item;
    });
    if (explanation && featured && !text(featured)) explanation.remove();
  }

  const init = scope => scope.querySelectorAll('[data-treatment-content]').forEach(enhance);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
